import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

const Perks = () => {
  return (
    <div
      className="Perks p-100 perks_devops"
      style={{ backgroundColor: "#F9F9F9" }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={10}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>
              Gain High-Level Support with an Automated DevOps{" "}
              <span>Enablement Model</span>
            </h2>
          </Col>
        </Row>
        <Row className="h-100 perks-padd">
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-lg-5 mb-xl-0">
            <div className="perks-box perks_web">
              <div className="perks-content ">
                <h4>
                  DevOps
                  <br /> Enablement
                </h4>
                <p>
                  Tekrevol’s end-to-end DevOps enablement is dedicated to
                  providing high-level support with a range of services that
                  enhance cross-departmental collaboration, while eliminating
                  silos, and improving the speed to digital transformation.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-lg-5 mb-xl-0">
            <div className="perks-box perks_web">
              <div className="perks-content">
                <h4>
                  DevOps Consultancy
                  <br />
                  Services
                </h4>
                <p>
                  Our DevOps consultancy services provide you a holistic picture
                  of technology infrastructure, enabling you to take a proactive
                  approach towards cross-functional collaboration, enhancing
                  operations, and making your desired outcomes more probable.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
            <div className="perks-box perks_web">
              <div className="perks-content">
                <h4>
                  DevOps Environment <br />
                  Design Services
                </h4>
                <p>
                  Environment design is key to efficient, high-performing
                  cloud-base development. We work closely with teams to ensure
                  that hardware, software, and networking setup work in full
                  coherence to guarantee the achievement of set goals.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
            <div className="perks-box perks_web">
              <div className="perks-content">
                <h4>
                  DevOps Organization <br />
                  Setup
                </h4>
                <p>
                  Our DevOps enablement services also encompass dedicated
                  organization setup, providing adequate operations training to
                  professionals. This ensures that professionals at service
                  providers team are able to swiftly onboard cutting-edge DevOps
                  processes, and practices.
                </p>
              </div>
            </div>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="m-auto text-center"
          >
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Discover Now
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Perks;
